import ContentTypes from "../../../../../lib/html5-software-library/src/ranj/eng/content/ContentTypes";
import AbstractCommand from "../../../core/application/AbstractCommand";
import SaveGameEvent from "../../save-game/events/SaveGameEvent";
import KeyDecisionEvent from "../event/KeyDecisionEvent";
import KeyDecision from "../model/KeyDecision";
import KeyDecisionsConfig from "../model/KeyDecisionsConfig";
import KeyDecisionsModel from "../model/KeyDecisionsModel";

export default class KeyDecisionCompletedCommand extends AbstractCommand {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher 
     * @param {KeyDecisionsModel} keyDecisionsModel 
     * @param {KeyDecisionsConfig} keyDecisionsConfig 
     */
    constructor(dispatcher, keyDecisionsModel, keyDecisionsConfig) {
        super(dispatcher);
        this._dispatcher = dispatcher;
        this._keyDecisionsModel = keyDecisionsModel;
        this._keyDecisionsConfig = keyDecisionsConfig;
    }

    execute(evt) {
        /** @type {KeyDecisionEvent} */
        const data = evt.params.data;
        const keyDecision = data.keyDecision;
        const keyDecisionContent = keyDecision.content;

        const contentType = keyDecisionContent.getType();
        switch (contentType) {
            case ContentTypes.TYPE_EMAIL_DRAFT:
                this._handleDraftEmailContent(keyDecision);
                break;
        }
    }

    /**
     * @param {KeyDecision} keyDecision 
     */
    _handleDraftEmailContent(keyDecision) {
        
    }
}